import React from 'react';
import i18n from 'i18n-js';

import ViewHeader from '../../layouts/AppHeader';
import ViewContent from './ViewContent';

export default function NewAudit(props) {
  return (
    <>
      <div className="view">
        <ViewHeader title={i18n.t('audit_title')} subtitle={i18n.t('audit_subtitle')} />
        <ViewContent fullMonth={props.fullMonth} />
      </div>
    </>
  );
}
